import { useTranslation } from "react-i18next";

import Cell from "../../components/common/AccordionTable/components/Cell";
import DropdownItem from "../../components/common/AccordionTable/components/DropdownTableMenu/components/DropdownItem";

export const useEvercookieAdapter = () => {
  const { t } = useTranslation();

  const headerData = [t("global.name"), t("global.result")];

  const getValue = result => {
    return result === "N/A" || result === "" ? t("global.undefined") : result;
  };

  const renderRowContent = item => {
    const value = getValue(item.result);

    return (
      <>
        <Cell>{item.name}</Cell>
        <Cell>{value}</Cell>
      </>
    );
  };

  const renderHeaderTitle = item => item.name;

  const renderDropdownContent = item => {
    const value = getValue(item.result);

    return (
      <DropdownItem>
        <span>{headerData[1]} </span>
        {value}
      </DropdownItem>
    );
  };

  return {
    headerData,
    renderRowContent,
    renderHeaderTitle,
    renderDropdownContent,
  };
};
